"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFallbacks = void 0;
const SANS_SERIF = 'sans-serif';
exports.fontFallbacks = {
    Aleo: SANS_SERIF,
    'Clear Sans': SANS_SERIF,
    'Cooper Hewitt': SANS_SERIF,
    Lato: 'Avenir, Adobe Heiti Std, Segoe UI, Trebuchet MS, sans‑serif',
    'Source Sans Pro': 'Apple SD Gothic Neo, PT Sans, Trebuchet MS, sans‑serif',
};
